/**
 * Generates a standardized name for the Redux DevTools store.
 *
 * This name is displayed in the Redux DevTools extension to help identify
 * which store is being observed.
 *
 * @param id - The unique identifier for the store.
 * @returns A string formatted for use in devtools (e.g., "userStore").
 */
export const getDevtoolsName = (id: string): string => `${id}Store`;
